import useSafeArray from './useSafeArray';

// normalizes raw rows and derives the empty-state flag so the table component
// stays presentational
const useLifecareStudioTable = ({ rows }) => {
  const safeRows = useSafeArray(rows);
  return { safeRows, hasRows: safeRows.length > 0 };
};

export default useLifecareStudioTable;
